// extracted by mini-css-extract-plugin
var _1 = "src-components-EditNotePage-_LoadingModalDialog__loadingSpinner--C6qqq3CGvqb0XREB2lNo";
var _2 = "src-components-EditNotePage-_LoadingModalDialog__loginProcessingModalDialog--fUFLXu3ZNe6GcmFAkcDi";
var _3 = "src-components-EditNotePage-_LoadingModalDialog__spin--X6pmTsVAB0oBnLNS4V5i";
export { _1 as "loadingSpinner", _2 as "loginProcessingModalDialog", _3 as "spin" }
